/**
 * Lockstep Platform SDK for TypeScript
 *
 * (c) 2021-2023 Lockstep, Inc.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author     Lockstep Network <support@lockstep.io>
 * @copyright  2021-2023 Lockstep, Inc.
 * @link       https://github.com/Lockstep-Network/lockstep-sdk-typescript
 */
export class InvoiceLinesClient {
    /**
     * Internal constructor for this client library
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Creates one or more invoice lines within this account and returns the created records
     *
     * @param body Documentation pending
     */
    createInvoiceLine(body) {
        const url = `/api/v1/invoice-lines`;
        return this.client.request("post", url, null, body);
    }
    /**
     *
     * @param body The unique Lockstep Platform ID numbers of the Invoice Lines to delete; NOT the customer's ERP keys
     */
    deleteInvoiceLines(body) {
        const url = `/api/v1/invoice-lines`;
        return this.client.request("delete", url, null, body);
    }
    /**
     *
     * @param invoiceLineId Unique id of the the InvoiceLine
     */
    retrievesInvoiceLine(invoiceLineId) {
        const url = `/api/v1/invoice-lines/${invoiceLineId}`;
        return this.client.request("get", url, null, null);
    }
    /**
     * Updates an existing Invoice Line with the information supplied to this PATCH call.
     *
     * The PATCH method allows you to change specific values on the object while leaving other values alone. As input you should supply a list of field names and new values.  If you do not provide the name of a field, that field will remain unchanged. This allows you to ensure that you are only updating the specific fields desired.
     *
     * @param invoiceLineId Unique id of the the InvoiceLine
     * @param body A list of changes to apply to this Invoice Line
     */
    updateInvoiceLine(invoiceLineId, body) {
        const url = `/api/v1/invoice-lines/${invoiceLineId}`;
        return this.client.request("patch", url, null, body);
    }
    /**
     *
     * @param invoiceLineId Unique id of the the InvoiceLine
     */
    deletesInvoiceLine(invoiceLineId) {
        const url = `/api/v1/invoice-lines/${invoiceLineId}`;
        return this.client.request("delete", url, null, null);
    }
    /**
     * Queries Invoice Lines for the account using specified filtering More information on querying can be found on the [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight) page on the Lockstep Developer website.
     *
     * @param filter The filter for this query. See [Searchlight Query Language](https://developer.lockstep.io/docs/querying-with-searchlight)
     * @param include To fetch additional data on this object, specify the list of elements to retrieve.
     * @param order The sort order for the results, in the [Searchlight order syntax]
     * @param pageSize The page size for results (default 200, maximum of 10,000)
     * @param pageNumber The page number for results (default 0)
     */
    queryInvoiceLines(filter, include, order, pageSize, pageNumber) {
        const url = `/api/v1/invoice-lines/query`;
        const options = {
            params: {
                filter,
                include,
                order,
                pageSize,
                pageNumber,
            },
        };
        return this.client.request("get", url, options, null);
    }
}
//# sourceMappingURL=InvoiceLinesClient.js.map